/**
 * VendorPortalDonationService
 * Service for viewing vendor donations (read-only).
 * Route: api/vendor-portal/donations
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalDonationService
 * Handles vendor donation viewing for the vendor portal (read-only).
 * Maps to /api/vendor-portal/donations endpoint
 */
export class VendorPortalDonationService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalDonationService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalDonationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all donations for the current vendor
     * GET /api/vendor-portal/donations
     */
    async getDonations() {
        const response = await this.getDonationsRaw();
        return response.data ?? [];
    }
    /**
     * Get all donations (raw response)
     */
    getDonationsRaw() {
        return this.get();
    }
    // ==================== GET BY ID ====================
    /**
     * Get a specific donation by ID
     * GET /api/vendor-portal/donations/{id}
     */
    async getDonation(id) {
        const response = await this.getDonationRaw(id);
        if (!response.data) {
            throw new Error(`Donation with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific donation (raw response)
     */
    getDonationRaw(id) {
        return this.get(String(id));
    }
}
VendorPortalDonationService.DEFAULT_SERVICE_PATH = 'vendors';
VendorPortalDonationService.BASE_PATH = 'api/vendor-portal/donations';
//# sourceMappingURL=VendorPortalDonationService.js.map